<template>
  <div class="card__header flex flex--desktop flex--between">
    <div>
      <h2 class="type-h3 no-bottom-margin">Shopping Cart</h2>
      <h3 class="type-regular type-bold add-bottom-margin">
        Subtotal ({{ TotalProducts }} items): {{ SubTotal }}
      </h3>
    </div>
    <div>
      <button
        class="btn btn--disabled"
        disabled="disabled"
        v-if="hasItemsOutOfStock"
      >
        Continue to Checkout
      </button>
      <a :href="url" @click="handleSubmit" class="btn" v-else
        >Continue to Checkout</a
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "CartTotal",
  data() {
    return {};
  },

  methods: {
    handleSubmit(e) {
      // console.log('submit cart');
      e.preventDefault();
      if (window.fbq) {
        window.fbq("track", "InitiateCheckout");
      }
      window.location = this.url;
    },
  },
  computed: {
    ...mapState({
      SubTotal: (state) => state.cartStore.SubTotal,
      TotalProducts: (state) => state.cartStore.TotalProducts,
    }),

    ...mapGetters(["hasItemsOutOfStock"]),

    url() {
      return `${window.env.ZOHRAB_SHOP_DOMAIN}/checkout`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CartTotal.vue